import {DataStatus} from 'platform/components';
import {Box} from 'platform/foundation';

import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {isNotNil} from 'ramda';

import {useGetVehicleQuery} from '@dms/api/sales';
import {
  getCustomTenantCatalogue,
  getVehicleMakeModels,
  selectCarAudit,
  useThunkDispatch,
} from '@dms/teas';

import {useRequiredParams} from 'shared/web';

import {VehicleDocuments} from './components/VehicleDocuments';

export const Documents = () => {
  const dispatch = useThunkDispatch();

  const {id: vehicleId} = useRequiredParams();
  const {data: vehicle} = useGetVehicleQuery({vehicleId});

  const {loading} = useSelector(selectCarAudit);
  const isAuditLoading = loading['vehicleCatalogue/getCustomTenantCatalogue'];

  useEffect(() => {
    if (isNotNil(vehicleId) && isNotNil(vehicle) && !isAuditLoading) {
      Promise.all([
        dispatch(
          getVehicleMakeModels.action({
            vehicleType: vehicle.type!,
            make: vehicle.make,
          })
        ),
        dispatch(getCustomTenantCatalogue.action({})),
      ]);
    }
  }, [vehicle, vehicleId]);

  return (
    <Box flex={1} minWidth={0}>
      <DataStatus isLoading={isAuditLoading} minHeight={100}>
        <VehicleDocuments />
      </DataStatus>
    </Box>
  );
};
